<rnb-table-filters [tableFilters]="filters$ | async" [defaultFilters]="defaultFilters$ | async" (filtersChanged)="filtersChanged($event)"></rnb-table-filters>
<rnb-table
  #table
  [data]="channels$ | async"
  [defaultSortActive]="(defaultSort$ | async).active"
  [defaultSortDirection]="(defaultSort$ | async).direction"
  [columns]="columns"
  [hasBulk]="true"
  [hasActions]="true"
  [bulkPredicate]="bulkPredicate"
  [pagination]="pagination$ | async"
  [totalObs]="total$"
  [isLoading]="isLoading$ | async"
  [highlight]="search$ | async"
  (sortChanged)="sortChanged($event)"
  (paginationChanged)="paginationChanged($event)"
  (selectionChanged)="selectionChanged($event)"
  (linkClicked)="onLinkClick($event)"
  [filtersApplied]="((filters$ | async) | isSameObject: (defaultFilters$ | async)) === false"
  >
  <span bulkText>
    {{table.selectedCount}} Channel{{table.selectedCount > 1? 's ':' '}} selected 
  </span>
  <ng-container bulkActions>
    <button rds-warning-button (click)="deleteChannels(table.selection)">Delete</button>
  </ng-container>

  <span emptyTitle>
    Looks like you don’t have any role in any channel yet.
  </span>
  <span emptySubtitle>
    You can contact a Channel Owner or Manager to add you a role in their channel (see All Channels) or create your own channel.
  </span>

  <ng-template #actions let-channel>
    <button rds-icon-button size="m" [rdsMenuTriggerFor]="menu"
    #trigger="rdsMenuTrigger">
      <rds-icon namespace="filled" icon="more_vertical"></rds-icon>
    </button>

    <rds-menu #menu="rdsMenu">
      <button [disabled]="!canEditChannel(channel)" rds-menu-item [routerLink]="'/channel/'+channel.id+'/edit'" [state]="{redirect: 'channels'}">
        <span>Edit</span>
      </button>
      <button [disabled]="!bulkPredicate(channel)" rds-menu-item (click)="deleteChannel(channel.id, channel.name)">
        <span>Delete</span>
      </button>
    </rds-menu>
  </ng-template>
</rnb-table>
